module.exports = __webpack_public_path__ + "static/img/low.185d5d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/low.jpg
// module id = xyQ9
// module chunks = 13